import { MediaUploadDto } from 'collaboration-service';
import { Button, ButtonKind, ButtonProps, ImgIcons, Tooltip, TooltipProps } from 'imaginarity-react-ui';
import * as _ from "lodash";
import * as React from 'react';

export interface SelectFileModuleProps {
    fileSelected: (file: File | undefined, media: MediaUploadDto) => void;
    filesSelected: (file: File[] | undefined, medias: MediaUploadDto[]) => void;
    buttonProps: Partial<ButtonProps>;
}

interface IFileSelectorProps {
    onFileSelected?: (file: File | undefined, media: MediaUploadDto) => void;
    onFilesSelected?: (file: File[] | undefined, medias: MediaUploadDto[]) => void;
    filter?: string;
    floated?: "left" | "right" | undefined;
    content?: string;
    icon?: ImgIcons;
    kind?: ButtonKind;
    children?: (p: SelectFileModuleProps) => JSX.Element;
    tooltip?: Omit<TooltipProps, "children">;
}

const FileSelector = (p: IFileSelectorProps) => {
    const { onFileSelected, onFilesSelected, filter, floated, children, content, icon, kind, tooltip } = p;
    const selector = React.useRef<HTMLInputElement>(document.createElement("input"));


    const fileSelectedInt = React.useMemo(() => {
        return (file: File | undefined, media: MediaUploadDto) => {
            if (onFileSelected)
                onFileSelected(file, media);
        }
    }, [onFileSelected]);

    const filesSelectedInt = React.useMemo(() => {
        return (files: File[] | undefined, medias: MediaUploadDto[]) => {
            if (onFilesSelected)
                onFilesSelected(files, medias);
        }
    }, [onFilesSelected]);

    const openFileDlg = React.useMemo(() => {
        return () => {
            selector.current.click();
        }
    }, []);

    const fileSelected = React.useMemo(() => {
        return (e: any) => {
            if (onFileSelected) {
                //        console.log(e.target.files);
                const val = e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined;
                onFileSelected(val, { fileName: val.name, mediaType: val.type, changed: true, thumbnails: [], reference: "" });
                selector.current.value = "";
            }
            if (onFilesSelected) {
                const val = e.target && e.target.files && e.target.files.length > 0 ? _.map(e.target.files, f => f) : undefined;
                onFilesSelected(val, _.map(val, v => ({ fileName: v.name, mediaType: v.type, changed: true, thumbnails: [], reference: "" })));
                selector.current.value = "";
            }
        }
    }, [onFileSelected, onFilesSelected]);


    React.useEffect(() => {
        selector.current.type = "file";
    }, [])

    React.useEffect(() => {
        selector.current.accept = filter ?? "";
    }, [filter])

    React.useEffect(() => {
        selector.current.setAttribute("multiple", onFilesSelected ? "true" : "false");
    }, [onFilesSelected])

    React.useEffect(() => {
        selector.current.onchange = fileSelected;
    }, [fileSelected])



    const buttonProps = React.useMemo(() => {
        const toRet: Partial<ButtonProps> = {
            kind: "cancelButton",
            floated: floated,
        }
        return toRet;
    }, [floated]);
    if (!tooltip)
        return (
            <>
                <Button
                    onClick={openFileDlg}
                    {...buttonProps}
                    icon={icon ?? "upload"}
                    content={content ?? "Attach"}
                    kind={kind ?? undefined}
                />
                {children !== undefined &&
                    children({
                        filesSelected: filesSelectedInt,
                        fileSelected: fileSelectedInt,
                        buttonProps
                    })
                }
            </>
        );
    else
        return (
            <>
                <Tooltip {...tooltip}>
                    <Button
                        // kind="secondary"
                        onClick={openFileDlg}
                        {...buttonProps}
                        content={content ?? "Attach"}
                        icon={icon ?? "upload"}
                        kind={kind ?? "secondary"}
                    />
                </Tooltip>
                {children !== undefined &&
                    children({
                        filesSelected: filesSelectedInt,
                        fileSelected: fileSelectedInt,
                        buttonProps
                    })
                }
            </>
        );
}
export default FileSelector;